import { render, staticRenderFns } from "./PersonalCenterMenu.vue?vue&type=template&id=65d6bcb0&scoped=true"
import script from "./PersonalCenterMenu.vue?vue&type=script&lang=js"
export * from "./PersonalCenterMenu.vue?vue&type=script&lang=js"
import style0 from "./PersonalCenterMenu.vue?vue&type=style&index=0&id=65d6bcb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d6bcb0",
  null
  
)

export default component.exports